(()=>{
const root=document.querySelector('#nl-dtf-preview,#nl-emb-preview,#nl-hat-preview');
if(!root)return;
const strings=JSON.parse(document.getElementById('nl-polish-strings').textContent);
const isHat=root.id==='nl-hat-preview';
const hatProduct=JSON.parse(document.getElementById(root.id.replace('-preview','-product')).textContent);
const openColors=new Map();
let scheduled=false;
function placeSavings(){
 const review=document.querySelector('#nl-dtf-selection-price,#nl-emb-selection-price,#nl-hat-selection-price');
 const savings=document.getElementById('mv_discount_summary');
 if(review&&savings&&savings.parentElement!==review)review.append(savings);
 savings?.querySelectorAll('.mv_ds_card').forEach(card=>{
  const active=String(!!card.style.borderBottomColor&&card.style.borderBottomColor!=='transparent');
  if(card.dataset.nlTierActive!==active)card.dataset.nlTierActive=active;
 });
}
function refresh(){
 scheduled=false;if(root.hidden)return;
 if(!document.body.classList.contains('nl-polish'))document.body.classList.add('nl-polish');
 const price=root.parentElement.querySelector('[id^=price-]');
 if(price&&!price.querySelector('.nl-base-label')){const label=document.createElement('span');label.className='nl-base-label';label.textContent=strings.blank;price.prepend(label);}
 document.querySelectorAll('.mv_grid').forEach(grid=>{
  if(!grid.classList.contains('nl-order-grid')){
   grid.classList.add('nl-order-grid');
   grid.classList.add('nl-hat-order-grid');
   if(!isHat)grid.classList.add('nl-shirt-order-grid');
   const heads=[...grid.querySelectorAll(':scope>.mv_grid_row_head')];
   heads.forEach((head,index)=>{
    const color=head.getAttribute('data-mvf-opt0');
    const cells=[...grid.querySelectorAll(':scope>.mv_grid_cell')].filter(cell=>cell.getAttribute('data-mvf-opt0')===color);
    if(!cells.length)return;
    const card=document.createElement('div');card.className='nl-order-card';card.dataset.color=color;
    card.open=openColors.has(color)?openColors.get(color):index===0;
    const summary=document.createElement('div');
    summary.className='nl-hat-card-heading';
    const count=document.createElement('span');count.className='nl-order-count';
    summary.append(head,count);
    const sizes=document.createElement('div');sizes.className='nl-order-sizes';sizes.append(...cells);
    card.append(summary,sizes);grid.append(card);
    {
     const image=head.querySelector('img');
     if(image){
      const variant=hatProduct.variants.find(v=>v.option1===color&&v.featured_image);
      const full=variant?.featured_image?.src||image.getAttribute('fsrc')||image.src;
      const photo=document.createElement('button');photo.type='button';photo.className='nl-hat-photo';
      photo.setAttribute('aria-label',strings.enlarge+' '+color);
      image.removeAttribute('onclick');image.src=full+(full.includes('?')?'&':'?')+'width=600';image.loading='lazy';image.decoding='async';image.width=400;image.height=300;
      photo.append(image);card.prepend(photo);
      head.querySelector('.multivariants_block_img_holder')?.remove();
      const caption=document.createElement('span');caption.textContent=strings.enlarge;photo.append(caption);
      photo.addEventListener('click',()=>showHatPhoto(full,color));
     }
    }
    card.addEventListener('toggle',()=>openColors.set(color,card.open));
    cells.forEach(cell=>{
     const input=cell.querySelector('input[type=number]');const size=cell.getAttribute('data-mvf-opt1')||'';
     if(input)input.setAttribute('aria-label',color+' / '+size+' / '+strings.quantity);
     cell.querySelectorAll('.multivariants_block_qty_box_left,.multivariants_block_qty_box_right').forEach(button=>{
      const increase=button.classList.contains('multivariants_block_qty_box_left');
      button.setAttribute('role','button');button.setAttribute('tabindex','0');
      button.setAttribute('aria-label',(increase?strings.increase:strings.decrease)+' '+color+' / '+size);
      button.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();event.stopPropagation();button.click();}});
     });
    });
   });
   if(!grid.parentElement.querySelector('.nl-order-intro')){
    const intro=document.createElement('div');intro.className='nl-order-intro';
    intro.innerHTML='<svg aria-hidden="true" viewBox="0 0 32 32" fill="none"><path d="M10 5 4 8 1 15l6 3 2-4v14h14V14l2 4 6-3-3-7-6-3c-2 5-10 5-12 0Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
    const eyebrow=document.createElement('p');eyebrow.className='nl-eyebrow';eyebrow.textContent=strings.step;
    const title=document.createElement('h2');title.textContent=strings.title;
    const note=document.createElement('p');note.textContent=isHat?strings.hatNote:strings.shirtNote;
    intro.append(eyebrow,title,note);grid.before(intro);
   }
  }
  grid.querySelectorAll('.nl-order-card').forEach(card=>{
   const inputs=[...card.querySelectorAll('input[type=number]')];
   const qty=inputs.reduce((sum,input)=>sum+(Number(input.value)||0),0);
   inputs.forEach(input=>{const selected=String(Number(input.value)>0);if(input.dataset.nlSelected!==selected)input.dataset.nlSelected=selected;});
   const count=card.querySelector('.nl-order-count');const text=qty?qty+' '+strings.selected:(isHat?strings.hatChoose:strings.choose);
   if(count.textContent!==text)count.textContent=text;
   const selected=String(qty>0);if(count.dataset.selected!==selected)count.dataset.selected=selected;
   const header=card.querySelector('.mv_grid_row_head');const hidden=header?.style.display==='none'||header?.classList.contains('mv_filter_hide');
   if(!hidden&&document.querySelector('.mv_filter_select[data-mvf-level="0"]')?.value&&!card.open)card.open=true;
   if(card.hidden!==hidden)card.hidden=hidden;
  });
 });
 placeSavings();
}
let photoDialog;
function showHatPhoto(src,color){
 if(!photoDialog){
  photoDialog=document.createElement('dialog');photoDialog.className='nl-hat-photo-dialog';photoDialog.setAttribute('aria-label',strings.photo);
  const close=document.createElement('button');close.type='button';close.textContent=strings.close;close.addEventListener('click',()=>photoDialog.close());
  const image=document.createElement('img');const label=document.createElement('p');
  photoDialog.append(close,image,label);document.body.append(photoDialog);
  photoDialog.addEventListener('click',e=>{if(e.target===photoDialog){const r=photoDialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)photoDialog.close();}});
 }
 photoDialog.querySelector('img').src=src;photoDialog.querySelector('img').alt=color;photoDialog.querySelector('p').textContent=color;photoDialog.showModal();
}
function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(refresh);}}
const observer=new MutationObserver(schedule);observer.observe(document.getElementById('MainContent'),{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','style','class'],characterData:true});
document.addEventListener('input',schedule);document.addEventListener('change',schedule);document.addEventListener('click',schedule);refresh();
window.addEventListener('pagehide',()=>observer.disconnect(),{once:true});
})();
